<template>
  <aside
    id="slider"
    class="main-sidebar"
  >
    <section
      class="sidebar"
      v-if="currentUser"
    >
      <div class="user-panel">
        <div class="pull-left image">
          <img
            :src="userAvatar"
            class="img-circle"
            alt="User Image"
            @error="(e) => {e.target.src='/img/avatar.png'}"
          >
        </div>
        <div class="pull-left info">
          <p>{{ currentUser.name }}</p>
          <a href="javascript:void(0)">
            <i
              class="fa fa-circle"
              :style="`color:green`"
            /> Online</a>
        </div>
      </div>
      <ul class="sidebar-menu">
        <template v-for="(menu, key) in menus">
          <template v-if="menu.route === null && menu.children === null">
            <template v-if="can(menu.permissions) && hasRoles(menu.roles)">
              <li
                class="header"
                :key="key"
              >
                {{ menu.label }}
              </li>
            </template>
          </template>
          <template v-else-if="menu.route !== null && menu.children === null">
            <template v-if="can(menu.permissions) && hasRoles(menu.roles)">
              <li
                :class="{active: $route.meta.groups === menu.route.groups}"
                :key="key"
              >
                <router-link :to="menu.route">
                  <i :class="menu.icon" /> <span>{{ menu.label }}</span>
                  <template v-if="menu.badge && Array.isArray(menu.badge)">
                    <span class="pull-right-container">
                      <span
                        v-for="(badge, key_badge) in menu.badge"
                        :key="key_badge"
                        :class="badge.class"
                      >{{ badge.label }}
                      </span>
                    </span>
                  </template>
                </router-link>
              </li>
            </template>
          </template>
          <template v-else>
            <template v-if="can(menu.permissions) && hasRoles(menu.roles)">
              <tree-menu
                :menu="menu"
                :key="key"
              />
            </template>
          </template>
        </template>
      </ul>
    </section>
  </aside>
</template>

<script>
import TreeMenu from '@/components/TreeMenu'
import { mapGetters } from 'vuex'

export default {
  name: 'Navbar',
  components: {
    TreeMenu
  },
  data () {
    return {
      apiUrl: process.env.VUE_APP_API
    }
  },
  computed: {
    ...mapGetters([
      'currentUser'
    ]),
    menus () {
      return [
        {
          label: this.$t('menu.dashboard'),
          route: null,
          icon: null,
          children: null,
          permissions: [this.$Permissions.backend.manage]
        },
        {
          label: this.$t('menu.dashboard'),
          route: { name: 'dashboard', groups: 'dashboard' },
          icon: 'fa fa-home',
          children: null,
          permissions: [],
          badge: null
        },
        {
          label: this.$t('menu.applicant'),
          route: { name: 'list-applicant', groups: 'applicant' },
          icon: 'fa fa-file-text-o',
          children: null,
          permissions: [this.$Permissions.backend.applicant.manage],
          badge: [{ class: 'label pull-right bg-green', label: this.$t('string.pending') }]
        },
        {
          label: this.$t('menu.draft'),
          route: { name: 'list-draft', groups: 'draft' },
          icon: 'fa fa-pencil-square-o',
          children: null,
          permissions: [this.$Permissions.backend.draft.manage],
          badge: null
        },
        {
          label: this.$t('menu.borrower'),
          route: { name: 'list-client', groups: 'client' },
          icon: 'fa fa-user',
          children: null,
          permissions: [this.$Permissions.backend.client.manage],
          badge: null
        },
        {
          label: this.$t('menu.cancelled'),
          route: { name: 'list-cancelled', groups: 'cancelled' },
          icon: 'fa fa-ban',
          children: null,
          permissions: [this.$Permissions.backend.cancelled.manage],
          badge: null
        },
        {
          label: this.$t('menu.rejected'),
          route: { name: 'list-rejected', groups: 'rejected' },
          icon: 'fa fa-times-circle-o',
          children: null,
          permissions: [this.$Permissions.backend.rejected.manage],
          badge: null
        },
        {
          label: this.$t('menu.trash'),
          route: { name: 'list-trashed', groups: 'trashed' },
          icon: 'fa fa-trash',
          children: null,
          permissions: [this.$Permissions.backend.trashed.manage],
          badge: null
        },
        {
          label: this.$t('label.loan'),
          route: null,
          icon: 'fa fa-balance-scale',
          permissions: [this.$Permissions.backend.loan.manage],
          badge: null,
          children: [
            {
              label: this.$t('menu.payDayLoan'),
              route: { name: 'PayDayLoanList', groups: 'payday' },
              permissions: [this.$Permissions.backend.loan.payDay.list]
            },
            {
              label: this.$t('menu.personalLoan'),
              route: { name: 'PersonalLoanList', groups: 'personal' },
              permissions: [this.$Permissions.backend.loan.personal.list]
            },
            {
              label: this.$t('menu.pawnLoan'),
              route: { name: 'list-pawn-loan', groups: 'pawn' },
              permissions: [this.$Permissions.backend.loan.pawn.list]
            },
            {
              label: this.$t('menu.purchasingLoan'),
              route: { name: 'list-purchasing-loan', groups: 'purchasing' },
              permissions: [this.$Permissions.backend.loan.purchasing.list]
            }
          ]
        },
        {
          label: this.$t('label.interestRate'),
          route: null,
          icon: 'fa fa-money',
          permissions: [this.$Permissions.backend.interestRate.manage],
          badge: null,
          children: [
            {
              label: this.$t('menu.payDayLoanRate'),
              route: { name: 'InterestRate', groups: 'payday-interest-rate' },
              permissions: [this.$Permissions.backend.interestRate.payDay.list]
            },
            {
              label: this.$t('menu.personalLoanRate'),
              route: { name: 'PersonalLoanInterestRateList', groups: 'personal-interest-rate' },
              permissions: [this.$Permissions.backend.interestRate.personal.list]
            },
            {
              label: this.$t('menu.pawnInterestRate'),
              route: { name: 'list-pawn-interest-rate', groups: 'pawn-interest-rate' },
              permissions: [this.$Permissions.backend.interestRate.pawn.list]
            },
            {
              label: this.$t('menu.purchasingInterestRate'),
              route: { name: 'list-purchasing-interest-rate', groups: 'purchasing-interest-rate' },
              permissions: [this.$Permissions.backend.interestRate.purchasing.list]
            }
          ]
        },
        {
          label: this.$t('menu.profileScoring'),
          route: { name: 'list-criteria', groups: 'profileScoring' },
          permissions: [this.$Permissions.backend.profileScoring.list],
          icon: 'fa fa-adjust',
          children: null,
          badge: null
        },
        {
          label: this.$t('label.investAndReferral'),
          route: null,
          icon: null,
          children: null,
          permissions: [
            this.$Permissions.backend.invest.manage,
            this.$Permissions.backend.referral.manage
          ]
        },
        {
          label: this.$t('menu.invest'),
          route: { name: 'Invest', groups: 'invest' },
          icon: 'fa fa-bank',
          children: null,
          permissions: [this.$Permissions.backend.invest.list],
          badge: null
        },
        {
          label: this.$t('menu.referral'),
          route: { name: 'Referral', groups: 'referral' },
          icon: 'fa fa-paper-plane',
          children: null,
          permissions: [this.$Permissions.backend.referral.list],
          badge: null
        },
        {
          label: this.$t('menu.system'),
          route: null,
          icon: null,
          children: null,
          permissions: [this.$Permissions.backend.administration.manage]
        },
        {
          label: this.$t('menu.settings'),
          route: null,
          icon: 'fa fa-cog',
          permissions: [
            this.$Permissions.backend.setting.manage
          ],
          badge: null,
          children: [
            {
              label: this.$t('menu.membership'),
              route: { name: 'Membership', groups: 'membership' },
              permissions: [this.$Permissions.backend.setting.membership.list]
            },
            {
              label: this.$t('menu.background'),
              route: { name: 'list-background', groups: 'background' },
              permissions: [
                this.$Permissions.backend.setting.background.list,
                this.$Permissions.backend.setting.whyUsImage.list
              ]
            },
            {
              label: this.$t('menu.assignLoanOfficer'),
              route: { name: 'assign-loan-officer-list', groups: 'assignLoanOfficer' },
              permissions: [this.$Permissions.backend.setting.assignLoanOfficer.list]
            },
            {
              label: this.$t('menu.assignLoanOfficerOldClient'),
              route: { name: 'list-assign-loan-officer-old-client', groups: 'assign-loan-officer-old-client' },
              permissions: [this.$Permissions.backend.setting.assignLoanOfficerOldClient.list]
            },
            {
              label: this.$t('menu.reason'),
              route: { name: 'list-reason', groups: 'reason' },
              permissions: [this.$Permissions.backend.setting.reason.list]
            }
          ]
        },
        {
          label: this.$t('menu.administration'),
          route: null,
          icon: 'fa fa-code',
          permissions: [this.$Permissions.backend.administration.manage],
          badge: null,
          children: [
            {
              label: this.$t('menu.userList'),
              route: { name: 'list-user', groups: 'user' },
              permissions: [this.$Permissions.backend.administration.user.list]
            },
            {
              label: this.$t('menu.roleList'),
              route: { name: 'list-role', groups: 'role' },
              permissions: [this.$Permissions.backend.administration.role.list]
            },
            {
              label: this.$t('menu.permissionList'),
              route: { name: 'list-permission', groups: 'permission' },
              permissions: [this.$Permissions.backend.administration.permission.list]
            }
          ]
        }
      ]
    }
  }
}
</script>
